export const selectIsLoggedIn = state => state.auth.isLoggedIn;

export const selectIsOnBoard = state => state.auth.isOnBoard;

export const selectUser = state => state.auth.user;

export const selectToken = state => state.auth.access.token;

export const selectIsFetchingCurrentUser = state =>
  state.auth.isFetchingCurrentUser;
